import React from 'react';
import SignTimer from '../SignTimer';
import Loader from '../Loader';
import VideoPlayer from '../VideoPlayer';
import Keypad from '../Keypad';
import Measure from '../Measure';

function wrapperStyle({ styles }) {
  return {
    ...styles.toEdgeStyle,
    overflow: 'hidden'
  };
}

function getRedirectParams({ match, constants }) {
  const { vendorId } = match.params;

  return {
    redirect: `/vendor/${vendorId}`,
    duration: constants.REDIRECT_DURATION
  };
}

export default ({
  styles,
  color,
  constants,
  reset,
  sign,
  text,
  dimensions,
  stopAnimations,
  infoModeUpdate,
  keypadModeUpdate,
  keypadKeysShow,
  keypadShow,
  keypadClear,
  keypadKeyAdd,
  keypadKeyRemove,
  thankYouShow,
  requestSign,
  sendNumber,
  startRedirect,
  stopRedirect,
  redirect,
  match,
  updateDimensions
}) => (
  <div style={wrapperStyle({ styles })}>
    <Measure styles={styles} onChange={updateDimensions} />
    <SignTimer
      signId={match.params.signId}
      sign={sign}
      reset={reset}
      stopAnimations={() => {
        stopRedirect();
        stopAnimations();
      }}
      infoModeUpdate={infoModeUpdate}
      keypadShow={keypadShow}
      requestSign={() => {
        const { signId, vendorId } = match.params;
        requestSign({
          id: signId,
          redirect: `/vendor/${vendorId}`,
          duration: constants.REDIRECT_DURATION
        });
      }}
    />
    <VideoPlayer
      styles={styles}
      dimensions={dimensions}
      active
      url={sign.video.url}
      play={sign.loader.mode >= 7}
      slideLeft={sign.keypad.mode >= 1}
    />
    <Loader
      color={color}
      styles={styles}
      constants={constants}
      mode={sign.loader.mode}
      dimensions={dimensions}
      text={text}
      name={sign.name}
    />
    <Keypad
      text={text}
      styles={styles}
      color={color}
      constants={constants}
      dimensions={dimensions}
      mode={sign.keypad.mode}
      valid={sign.keypad.valid}
      number={sign.keypad.number}
      updateMode={keypadModeUpdate}
      showKeys={() => {
        stopRedirect();
        startRedirect(getRedirectParams({ match, constants }));
        keypadKeysShow();
      }}
      redirect={() => {
        const { vendorId } = match.params;

        reset();
        stopRedirect();
        redirect(`/vendor/${vendorId}`);
      }}
      submit={() => {
        const { number } = sign.keypad;
        const { vendorId } = match.params;

        // Will reset and stopRedirect in sendNumber.
        sendNumber(number, `/vendor/${vendorId}`);
      }}
      clear={() => {
        stopRedirect();
        startRedirect(getRedirectParams({ match, constants }));
        keypadClear();
      }}
      add={key => {
        stopRedirect();
        startRedirect(getRedirectParams({ match, constants }));
        keypadKeyAdd(key);
      }}
      remove={() => {
        stopRedirect();
        startRedirect(getRedirectParams({ match, constants }));
        keypadKeyRemove();
      }}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Sign/index.js